export default "__VITE_ASSET__DjCfSazf__"